module.exports = __webpack_public_path__ + "img/productWX_10.d6a723cf.jpg";